import React from "react";
import type { BreadcrumbsProps } from "./Breadcrumbs.d";

export default function Breadcrumbs({ items = [] }: BreadcrumbsProps) {
  return (
    <nav className="breadcrumbs">
      <ul>
        {items.map(([label, url], idx) => (
          <li key={idx}>
            {!url ? <span>{label}</span> : <a href={url}>{label}</a>}
          </li>
        ))}
      </ul>
    </nav>
  );
}
